import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const ForecastChart = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data}>
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip />
        <Line dataKey="actual" stroke="#8884d8" />
        <Line dataKey="forecast" stroke="#82ca9d" />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default ForecastChart;
